import EmberRouter from '@ember/routing/router';
import config from 'gyc/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('auth', { path: '' }, function () {
    this.route('smartphone');
    this.route('stadion');
    this.route('staff');
    this.route('sponsoring');
    this.route('fans');
    this.route('marketing');
    this.route('kalender');
    this.route('finanzen');
    this.route('liga');
    this.route('kader');
    this.route('training');
    this.route('taktik');
    this.route('jugend');
    this.route('transfermarkt');
  });
  this.route('login');
  this.route('register');
});
